import { CRAWLERS } from 'utils/constants';

export function crawlerCheck(userAgent: string | undefined): boolean {
  if (userAgent) {
    return CRAWLERS.some(crawler => userAgent.toLowerCase().includes(crawler));
  }

  return false;
}
